// Reading what was dropped on a drop zone: files, or whole folders (with their paths).

async function readAllEntries(reader) {
  const all = [];
  for (;;) {
    const batch = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));
    if (!batch.length) break;
    all.push(...batch);
  }
  return all;
}

async function walk(entry, prefix, out) {
  if (entry.isFile) {
    const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
    out.push({ file, path: prefix + entry.name });
  } else if (entry.isDirectory) {
    for (const child of await readAllEntries(entry.createReader())) await walk(child, `${prefix}${entry.name}/`, out);
  }
}

/** Resolves to [{ file, path }] for everything in a drop event's dataTransfer. */
export async function collectDropped(dataTransfer) {
  // Entries must be grabbed synchronously, before the drop event ends.
  const entries = [...(dataTransfer.items || [])].map((i) => i.webkitGetAsEntry?.()).filter(Boolean);
  if (!entries.length) return [...dataTransfer.files].map((file) => ({ file, path: file.name }));
  const out = [];
  for (const e of entries) await walk(e, "", out);
  return out;
}

/** From a file input's change event. */
export function filesFromInput(e) {
  const list = [...e.target.files].map((file) => ({ file, path: file.webkitRelativePath || file.name }));
  e.target.value = "";
  return list;
}

export const slugify = (text) =>
  (text || "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const IMAGE_FILE = /\.(png|jpe?g|webp)$/i;
